// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
// Translations provided by Vuetify
// import { en, es, fr } from 'vuetify/locale'
import fr from '/src/locales/fr.js'
import es from '/src/locales/es.js'
import en from '/src/locales/en.js'

// Vuetify
import { createVuetify } from 'vuetify'

const browserLanguage = navigator.language.toLowerCase()
let localLanguage = ''
if (browserLanguage.includes('fr')) {
  localLanguage = 'fr'
} else if (browserLanguage.includes('es')) {
  localLanguage = 'es'
} else {
  localLanguage = 'en'
}

export default createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  locale: {
    locale: localLanguage,
    fallback: 'en',
    messages: { en, es, fr }
  }
})
